import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchTransactionManagementPage = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getTransactionManagementPage',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, {
    endDate: payload.params.endDate !== null ? moment(payload.params.endDate).format('YYYY-MM-DD') : null,
    fromImpcs: payload.params.fromImpcs,
    status: payload.params.status,
    startDate: payload.params.startDate !== null ? moment(payload.params.startDate).format('YYYY-MM-DD') : null,
    toImpcs: payload.params.toImpcs,
    transactionTypeCode: payload.params.transactionTypeCode,
  });
};

export default apiFetchTransactionManagementPage;
